const DOC_ACCEPTED_TYPES = [
    "application/vnd.hancom.hwp",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/pdf",
    "image/tiff",
    "text/plain",
    "image/jpeg",
    "image/png",
    "application/x-hwp",
    "application/haansofthwp",
    "application/haansoft-hwp",
    "application/octet-stream",
    "application/zip",
    "application/x-zip-compressed",
    "multipart/x-zip",
    "application/vnd.ms-outlook",
    "message/rfc822",
];

function docTypeOk(file) {
    const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    return (
        DOC_ACCEPTED_TYPES.includes(file.type) ||
        (file.type === "" && ["hwp", "msg", "eml"].includes(extension.toLowerCase()))
    );
}

export function appendImageFiles(prevFiles, fileList, nextIdRef) {
    const selectFiles = Array.from(fileList || []).filter((f) => f.type.startsWith("image/"));
    if (selectFiles.length === 0) {
        if (fileList?.length) alert("이미지만 첨부할 수 있습니다.");
        return prevFiles;
    }

    const added = selectFiles.map((file) => ({
        id: nextIdRef.current++,
        object: file,
        originalName: file.name,
    }));

    return [...prevFiles, ...added];
}

export function appendDocFiles(prevFiles, fileList, nextIdRef) {
    const selectFiles = Array.from(fileList || []);
    if (selectFiles.length === 0) return prevFiles;

    const added = [];
    selectFiles.forEach((file) => {
        if (!docTypeOk(file)) {
            alert(`지원하지 않는 파일 형식입니다.\n형식 : ${file.type}`);
            return;
        }
        added.push({
            id: nextIdRef.current++,
            object: file,
            originalName: file.name,
        });
    });

    return [...prevFiles, ...added];
}
